import { render } from "./HomeContest.vue?vue&type=template&id=1fe33d27&scoped=true"
import script from "./HomeContest.vue?vue&type=script&lang=js"
export * from "./HomeContest.vue?vue&type=script&lang=js"

import "./HomeContest.vue?vue&type=style&index=0&id=1fe33d27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe33d27"]])

export default __exports__